/**
 * Avgör filtyp från en URL.
 *
 * Bodde tidigare i features/presentation/components/Lightbox, som exporterade
 * `isPdf`. När prislistans exempelbilaga också kunde vara en PDF behövde både
 * components/common/Bildvisare och tre vyer i features/ia-prislista samma
 * kontroll — och en delad komponent ska inte importera ur en feature. Lightbox
 * re-exporterar fortfarande `isPdf` från här, så presentationssliden som
 * importerar därifrån är orörd.
 */

/**
 * Är adressen en PDF?
 *
 * OBS: en blob-URL från URL.createObjectURL bär ingen ändelse, så en lokal
 * förhandsvisning av en nyvald fil måste avgöras på `file.type` i stället.
 *
 * @param {string} src
 * @returns {boolean}
 */
export const arPdf = (src) =>
  typeof src === 'string' && src.toLowerCase().split('?')[0].endsWith('.pdf');
